<!-- components/Page.svelte -->
<script>
  import { Link } from "svelte-routing";
  import { t, locale } from "../libs/i18n";

  export let locales
  let navbarMobile = false;
  let icon = 'bi-list';
  let toMobile = '';

  /**
   * Mobile nav toggle
   */
  function toggleMobilNav() {
		navbarMobile = !navbarMobile;
    icon = navbarMobile ? 'bi-x' : 'bi-list';
    toMobile = navbarMobile ? 'navbar-mobile' : '';
	}
</script>


  <div class="container d-flex align-items-center justify-content-between">
    
    <h1 class="logo"><Link to="/">{$t("homepage.appName")}</Link></h1>
    <!-- Uncomment below if you prefer to use an image logo -->
    <!-- <a href="index.html" class="logo"><img src="assets/img/logo.png" alt="" class="img-fluid"></a>-->

    <nav id="navbar" class="navbar {toMobile}">
      <ul>
        <li><Link to="/">{$t("nav.home")}</Link></li>
        <li><Link to="/course-yuka">{$t("nav.event")}</Link></li>
        <!--
        <li><Link to="/course">{$t("nav.course")}</Link></li>
        -->
        <li class="dropdown">
          <select class="lang-list" bind:value={$locale}>
            {#each locales as l}
              <option value={l}>{l}</option>
            {/each}
          </select>
        </li>
      </ul>

      <i class="bi bi-list mobile-nav-toggle {icon}" on:click={toggleMobilNav}></i>
    </nav><!-- .navbar -->

  </div>
